import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ReschedulesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

/** Loads the delivery-attempt cap from Constantes (DMS-35): the queue counts
 *  each delivery's attempts against it and flags the last one. */
export const loadMaxAttempts = createAsyncThunk<
  number,
  void,
  { dispatch: ReschedulesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LOAD_MAX_ATTEMPTS, async (_, { extra }) => {
  return await extra.reschedulesRepo.getMaxAttempts();
});
